// @ts-nocheck

import _ from "lodash";
import React from "react";

import accounting from "accounting";

import COUNTRY from "../../../constants/COUNTRY";



export const FormatNumber = (value, precision, thousand, decimal) => {
  const resetValue = accounting.formatNumber(value, 2, thousand, decimal);
  const nonDecimal = _.startsWith(
    _.last(
      _.split(resetValue, decimal)),
    "00"
  );
  const validPrecision = nonDecimal ? 0 : precision;
  return (accounting.formatNumber(value, validPrecision, thousand, decimal));
};

type ComponentPropsType = {
  value: number | string;
  precision: number;
}

export const Num = ({ value, precision }: ComponentPropsType) => {
  return (
    <>
      {accounting.formatNumber(value, (precision ? precision : COUNTRY.number.precision), COUNTRY.number.thousand, COUNTRY.number.decimal)}
    </>
  );
};
